// Attribution-Erfassung: gclid/gbraid/wbraid, UTMs, Referrer, Landing-Page.
// Beim ersten Besuch persistent gespeichert (localStorage), danach unveraendert.
const STORAGE_KEY = "ba_attribution";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];
const CLICK_IDS = ["gclid", "gbraid", "wbraid"];

function readStored() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

export function captureAttribution() {
  const stored = readStored();
  const params = new URLSearchParams(window.location.search);
  const fresh = {};

  CLICK_IDS.forEach((k) => {
    const v = params.get(k);
    if (v) fresh[k] = v;
  });
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) fresh[k] = v;
  });

  const merged = {
    ...fresh,
    ...stored, // erster Besuch gewinnt (first-touch) fuer bereits gespeicherte Werte
  };

  // Felder nur beim allerersten Besuch setzen
  if (!stored.first_seen) {
    merged.first_seen = new Date().toISOString();
    merged.referrer = document.referrer || "";
    merged.landing_page = window.location.pathname + window.location.search;
    merged.device = /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop";
  }

  // frische Click-IDs immer aktualisieren (neue Kampagne)
  CLICK_IDS.concat(UTM_KEYS).forEach((k) => {
    if (fresh[k]) merged[k] = fresh[k];
  });

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch {}
  return merged;
}

export function getAttributionPayload() {
  return readStored();
}
